// @ts-strict-ignore
import React from "react";

import Card from "./Card";

const label: React.CSSProperties = { color: "#6b7280", fontSize: 12 };
const value: React.CSSProperties = { fontWeight: 500 };

const editBtn = (
  <button
    style={{
      padding: "6px 12px",
      borderRadius: "999px",
      border: "1px solid #8b5cf6",
      color: "#7c3aed",
      background: "#f5f3ff",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    Edit Billing Address
  </button>
);

const gridRow: React.CSSProperties = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 };

const BillingDetailsCard: React.FC = () => {
  return (
    <Card title="Billing Details" action={editBtn}>
      <div style={gridRow}>
        <div>
          <div style={label}>Billing Name</div>
          <div style={value}>Alpha Dev</div>
        </div>
        <div>
          <div style={label}>Email Address</div>
          <div style={value}>info@alphasquad.tech</div>
        </div>
      </div>
      <div style={{ height: 1, background: "#e5e7eb", margin: "12px 0" }} />
      <div style={gridRow}>
        <div>
          <div style={label}>Phone Number</div>
          <div style={value}>+123 456 7890</div>
        </div>
        <div>
          <div style={label}>GSTIN</div>
          <div style={value}>06ABCDE1234F1Z5</div>
        </div>
      </div>
      <div style={{ height: 1, background: "#e5e7eb", margin: "12px 0" }} />
      <div>
        <div style={label}>Billing Address</div>
        <div style={value}>
        4275 Executive Square, Suite 200, LA Jolla
          <br />
          CA 92037, USA
          <br />
          USA
        </div>
      </div>
    </Card>
  );
};

export default BillingDetailsCard;
